// automatic transpilation and polyfills w/ Babel - https://babeljs.io/docs/en/index.html
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// dependencies
import 'jquery';
import 'bootstrap';
import 'slick-carousel-latest';
import './vendor/jquery-slick-filterable';
import 'flatpickr';

// manual polyfills
import './polyfills/polyfills';


// dataLayer scripts
import './datalayer/index';

import './components/address-book/address-book';
import './components/cart-landing/cart-landing';
import './components/cart-landing/cart-summary';
import './components/checkout/checkout-billing';
import './components/checkout/checkout-summary';
import './components/checkout/checkout-summary-promos';
import './components/checkout/checkout-shipping';
import './components/checkout/checkout-review';
import './components/pdp-selector/pdp-selector';
import './components/pdp-selector/pdp-quick-view';
import './components/mega-nav/mega-nav';
import './components/mega-nav/mobile-mega-nav';
import './components/mini-cart/mini-cart-toggle';
import './components/order-history/order-history';
import './components/return-to-top/back-to-top';
import './components/shop-landing/shop-50-50';
import './components/coveo-scripts-articles';
import './components/scrollToLink';
import './components/how-to-videos/how-to-videos';
import './components/add-to-cart';
import './components/menu';
import './components/50-50';
import './components/abstracts';
import './components/alert-banner';
import './components/feature-bar-parallax';
import './components/footer';
import './components/single-slide-slider';
import './components/inline-search';
import './components/listbox';
import './components/news-letter-cta';
import './components/service-slider';
import './components/referral-form';
import './components/custom-forms/form-loading';
import './components/custom-forms/form-loading-sitecore';
import './components/custom-forms/new-client-first-exam';
import './components/mobile-peek-slider';
import './components/stats-interactive';
import './components/story-carousel';
import './components/referral-interactive';
import './components/mutli-promo';
import './components/OAB/oab-from';
import './components/request-appt-form/request-appt-form';
import './components/CCDE/ccde-form';
import './components/pill-filters';
import './components/quantity-selector/quantity-selector';
import './components/breed-filters';
import './components/category-slider';
import './components/tooltips';
import './components/article-slider';
import './components/find-a-hospital/find-a-hospital';
import './components/find-a-hospital/uc-find-a-hospital';
import './components/find-a-hospital/find-a-search';
import './components/vca-voice/current-stories';
import './components/press-article-listing';
import './components/print';
import './components/product-card';
import './components/white-papers-slider';
import './components/home-redirect-device';
import './components/hospital-threecard-carousel';
import './components/hospital-header/header-modals';
import './components/hospital-header/header-site-search';
import './components/hospital-header/mobile-header-nav';
import './components/dashboard/header-components';
import './components/dashboard/pets-dropdown';
import './components/dashboard/cards-carousel';
import './components/dashboard/pet-photo';
import './components/dashboard/appt-tooltip';
import './components/add-to-calendar';
import './components/login';
import './components/account/guest-account-setup';
import './components/account/activate-account-setup';
import './components/account/forgot-password';
import './components/account/reset-password';
import './components/PCC/PCC-video-listing';
import './components/myVCA/navigation-tabs';
import './components/myVCA/account-settings';
import './components/myVCA/payment-management';
import './components/myVCA/account-change-hospital';
import './components/myVCA/individual-pet-profile';
import './components/myVCA/patient-documents';
import './components/myVCA/expert-guidance';
import './components/myVCA/care-club-membership';
import './components/myVCA/care-club-invoices';
import './components/myVCA/invoice-history';
import './components/myVCA/manage-subscriptions';
import './components/myVCA/manage-subscriptions-list';
import './components/custom-forms/vca-step-section-from';
import './components/subscriptions/delivery-address';
import './components/subscriptions/payment-method';
import './components/urgent-care/uc-vwr-form';
import './components/urgent-care/uc-wait-time';
import './components/newsletter-archive/newsletter-archive';
import './components/brand-pillars';
import './components/accordion';
import './components/product-walkthrough';
import './components/join-our-newsletter';
import './components/vetsouce-banner/vetsource-banner-modal';
import './components/hospital-action-panel';


if(process.env.NODE_ENV === 'development') {
    require('@api/mock/mock-server').default();
}

console.log('init');